export enum RoundUpOrientation {
	Left = 'left',
	Right = 'right',
}

export enum ButtonRole {
	Video = 'VideoCTA',
	Tour = 'VirtualTourCTA',
}
